import { Container, IDestroyOptions, Sprite, Text, TextStyle } from "pixi.js";
import { gsap } from "gsap";
import { CommonResourcesPackage } from "by/gamefactory/cityversetycoon/scenes/common/resources/CommonResourcesPackage";
type Timeline = gsap.core.Timeline;

export class YouWonHint extends Container {
    private static readonly AMAZING_RAID_TEXT = "Amazing Raid\nYou won\n";
    private static readonly COINS_TEXT = "game coins!";

    private readonly commonResources: CommonResourcesPackage;
    private hintText: Text;
    private hintArrow: Sprite;
    private animationTimeLine: Timeline;

    public constructor(commonResources: CommonResourcesPackage, coinsValue: number) {
        super();
        this.commonResources = commonResources;
        this.animationTimeLine = gsap.timeline({ paused: true });
        this.build(coinsValue);
        this.once("added", this.show.bind(this));
    }

    private build(coinsValue: number): void {
        this.hintText = new Text(`${YouWonHint.AMAZING_RAID_TEXT}${coinsValue} ${YouWonHint.COINS_TEXT}`, new YouWonTooltipTextStyle());
        this.hintText.angle = -13;
        this.hintText.anchor.set(0.5, 0.5);
        this.addChild(this.hintText);
        this.hintArrow = new Sprite(this.commonResources.assets_common_ui_hint_arrow_left_png);
        this.hintArrow.anchor.set(0, 0);
        this.hintArrow.angle = 200;
        this.hintArrow.position.set(this.hintText.x, this.hintText.y - this.hintText.height * 0.2);
        this.addChild(this.hintArrow);
    }

    private show(): void {
        this.animationTimeLine.fromTo(this.hintText.scale, { x: 0, y: 0 }, { x: 1, y: 1, duration: 0.1, ease: "back.out(2)" }, "<");
        this.animationTimeLine.fromTo(this.hintArrow.scale, { x: 0, y: 0 }, { x: 1, y: 1, duration: 0.1, ease: "back.out(2)" }, "<50%");
    }

    public updateArrowAlign(isOutOffsideHint: boolean): void {
        this.hintArrow.skew.y = isOutOffsideHint ? 3.15 : 0;
        this.hintArrow.angle = isOutOffsideHint ? 150 : 200
    }

    public playAnimations(): gsap.core.Timeline {
        this.animationTimeLine.then(() => this.animationTimeLine.kill());
        return this.animationTimeLine;
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.animationTimeLine?.kill();
        super.destroy(options);
    }
}

class YouWonTooltipTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            fontFamily: "Grapenuts Regular",
            fill: "#ffffff",
            fontSize: 80,
            align: "center"
        }));
    }
}
